import { RouteConfig } from 'vue-router';
import Form from '@/views/layout/Form.vue';
import i18n from '@/i18n';

const routes: Array<RouteConfig> = [
  {
    path: 'user',
    name: 'user',
    component: Form,
    redirect: { name: 'user-list' },
    meta: {
      session: true,
    },
    children: [
      {
        path: 'list',
        name: 'user-list',
        component: () => import('@/views/user/UserList.vue'),
        meta: {
          header: {
            label: () => i18n.tc('user.label', 2),
          },
        },
      },
      {
        path: 'create',
        name: 'user-create',
        component: () => import('@/views/user/UserCreate.vue'),
        meta: {
          header: {
            route: { name: 'user-list' },
            label: () =>
              i18n.t('title.create', [i18n.tc('user.label_title', 1)]),
          },
        },
      },
      {
        path: 'edit/:id(\\d+)',
        name: 'user-edit',
        component: () => import('@/views/user/UserEdit.vue'),
        meta: {
          header: {
            route: { name: 'user-list' },
            label: () => i18n.t('title.edit', [i18n.tc('user.label_title', 1)]),
          },
        },
      },
    ],
  },
];

export default routes;
